export default function(input, roundoffValue) {
    if (input < 0 || input === undefined || roundoffValue === undefined) {
        input = '';
    }
    else if (input > roundoffValue) {
        input = `${roundoffValue}+`;
    }
    return input;
}